// Словарь интерфейса (English). Ключ = либо смысловой (nav.*, col.*), либо английский оригинал.
const en = {
  // Выгрузка набора данных
  "Export dataset": "Export dataset",
  "Export dataset hint": "An archive with the annotations will be prepared: JSONL with segments, CSV tables and a manifest. It is built on the server and may take a while.",
  "Export format": "What to export",
  "Export format full": "Full set: JSONL, per-segment CSV, manifest",
  "Export format markup": "audio,text table — same as the input markup file (this dataset)",
  "Export format markup hint": "One row per file, file paths as in the original table. Text comes from the latest completed stage: super-check, review, annotation.",
  "Export layer": "Which text",
  "Export layer verbatim": "Verbatim (L1)",
  "Export layer normalized": "Normalised (L2)",
  "Include audio files": "Include audio files",
  "Include audio warning": "With audio the archive is large (several GB) and takes longer to build.",
  "Prepare export": "Prepare",
  "Export ready": "Export is ready",
  "Export failed": "Could not prepare the export",
  "Nothing to export": "Nothing to export: no submitted annotations",
  "Queued": "Queued",
  "Collecting records": "Collecting records",
  "Writing files": "Writing files",
  "Packing archive": "Packing archive",
  "records": "records",
  "segments": "segments",

  // Подсказки фичи отклонения файла: ключ ≠ готовому тексту, нужен перевод.
  "Reject file hint manager": "Does the file not meet requirements? Give a reason — the file will be excluded from work immediately and will not go to annotators. It will appear under \"Rejected Files\" with status \"Excluded\".",
  "Reject file hint":
    "The file does not meet the requirements? Specify a reason — it will be sent to the manager for review and leave your tasks. If the manager disagrees, the file returns to the common pool.",
  "Rejected files hint":
    "Files that annotators marked as not meeting the requirements. Confirm the rejection (the file is excluded) or return the file to the common pool.",
  // Сообщения бэкенда фичи отклонения (ключ на русском → английский текст).
  "Файл отправлен на проверку менеджеру": "File sent to the manager for review",
  "Файл исключён из работы": "File excluded from work",
  "Не удалось отклонить файл": "Failed to reject the file",
  "Вы не назначены аннотатором этой задачи":
    "You are not assigned as an annotator of this task",
  "Файл уже отправлен на проверку менеджеру":
    "The file has already been sent to the manager for review",
  "Некорректная причина отклонения": "Invalid rejection reason",
  "Отклонение подтверждено, файл исключён":
    "Rejection confirmed, the file is excluded",
  "Файл возвращён в общий пул": "The file has been returned to the common pool",
  "Недостаточно прав для рассмотрения отклонения":
    "Insufficient permissions to review the rejection",
  "Нет отклонения, ожидающего рассмотрения":
    "There is no rejection awaiting review",
  "Некорректное действие": "Invalid action",
  // --- legacy-ключи (используются в существующем коде, не удалять) ---
  landlingPageLabel: "CSI Annotator",
  enterEmailId: "Enter your Email ID*",
  enterPassword: "Enter your Password*",
  forgotPassword: "Forgot Password?",
  newPassword: "Enter your New Password*",
  currentPassword: "Enter your Current Password*",
  "label.appInfo": "CSI Annotator is a platform to annotate and label audio data at scale.",
  "button.clearAll": "Clear All",
  "button.clear": "Clear",
  "button.Filter": "Filter",
  "button.Apply": "Apply",
  "label.filter.status": "Status",
  "label.filter.byAnnotator": "Filter by Annotators",
  "label.filter.column": "Select Columns",
  "button.cancel": "Cancel",
  "button.addNewWorkspace": "Add New Workspace",
  "button.inviteNewMEmbersToOrganization": "Invite new members to organization",
  "button.notes": "Notes",
  "button.draft": "Draft",
  "button.next": "Next",
  "button.skip": "Skip",
  "button.submit": "Submit",
  "label.workspaces": "Workspaces",
  "label.members": "Members",
  "label.annotators": "Annotators",
  "label.reviewers": "Reviewers",
  "label.invites": "Invites",
  "label.settings": "Settings",
  "label.logs": "Logs",
  "label.tasks": "Tasks",
  "label.annotationTasks": "Annotation Tasks",
  "label.reviewTasks": "Review Tasks",
  "label.allTask ": "All Tasks",
  "label.reports": "Reports",
  "label.projectanalytics": "Project Analytics",
  "label.projects": "Projects",
  "label.managers": "Managers",
  "label.backToPreviousPage": "Back To Previous Page",
  "label.showProjectSettings": "Show Project Settings",
  "label.backToProject": "Back To Project",
  "alert.notes": "Please do not add notes if you are going to skip the task!",
  "label.datasets": "Datasets",
  "button.downloadDataset": "Download Dataset",
  "button.uploadData": "Upload Data",
  "link.Createanaccount": "Create an account",
  "tooltip.AnalyticsType": " The variation in chart with respect to the number of selected time ranges. In 'Individual', chart for a single time range is displayed. In 'Comparison', two different charts can be compared based on the time ranges selected. Default selection is 'Individual'.",
  "tooltip.ProjectType": " The type of the project for which the chart should be based on. Default selection is 'ContextualTranslationEditing'.",
  "tooltip.Baseperiod": "The time range selected for the first plot of the chart. Currently it can be cumulative, monthly or weekly. The default selection is 'Cumalative'.",
  "tooltip.ComparisonPeriod": "The time range selected for the second plot of the chart. This is applicable when the analytics type is Comparison. Currently it can be cumulative, monthly or weekly.",
  "label.recentTasks.annotation": "Annotations",
  "label.recentTasks.review": "Reviews",
  "button.deleteDataItems": "Delete Data Item",
  "label.Rate this translation": "Rate this translation",
  "button.Suggest an edit": "Suggest an edit",
  "button.Your feedback": "Your feedback will be used to help improve the product",
  "label.analytics": "Analytics",

  // --- навигация / шапка ---
  "nav.organization": "Organization",
  "nav.admin": "Admin",
  "menu.myProfile": "My Profile",
  "menu.myProgress": "My Progress",
  "menu.changePassword": "Change Password",
  "menu.logout": "Logout",
  "menu.signedInAs": "Signed in as",
  "tooltip.notifications": "Notifications",
  "tooltip.userOptions": "User Options",

  // --- логин ---
  "login.title": "Sign in to CSI Annotator",
  "login.button": "Login",

  // --- общее / таблицы ---
  "common.view": "View",
  "common.search": "Search",
  "common.actions": "Actions",
  "common.action": "Action",
  "common.status": "Status",
  "common.name": "Name",
  "common.id": "Id",
  "common.noRecords": "No records",
  "common.rowsPerPage": "Rows per page:",
  "common.jumpToPage": "Jump to Page:",
  "common.createdBy": "Created By",
  "view.list": "List",
  "view.card": "Card",
  "view.label": "View :",

  // --- список проектов ---
  "col.projectId": "Project Id",
  "col.projectTitle": "Project Title",
  "col.projectType": "Project Type",
  "col.projectStage": "Workflow",
  "col.targetLanguage": "Target Language",
  "col.workspaceId": "Workspace Id",
  "col.domain": "Domain",
  "col.scenario": "Scenario",
  "col.audioDuration": "Audio Duration",
  "col.referenceRawTranscript": "Reference Raw Transcript",
  "col.annotatorEmail": "Annotator Email",

  // --- проект: вкладки и действия ---
  "proj.addNewAnnotationProject": "Add New Annotation Project",
  "proj.pullNewBatch": "Pull New Batch",
  "proj.pullSize": "Pull Size",
  "proj.deallocate": "De-allocate Tasks",
  "proj.startLabelling": "Start Labelling Now",
  "proj.startReviewing": "Start reviewing now",
  "proj.annotate": "Annotate",
  "proj.review": "Review",
  "proj.unassignedAnnotationTasks": "Unassigned Annotation Tasks",
  "proj.unassignedReviewTasks": "Unassigned Review Tasks",
  "proj.description": "Description",
  "proj.published": "Published",

  // --- редактор транскрипции ---
  "editor.speakerDetails": "Speaker Details",
  "editor.provideTranscription": "Provide Transcription",
  "editor.referenceTranscript": "Reference Transcript",
  "editor.verbatim": "Verbatim Transcription",
  "editor.semanticL2": "Semantic (L2) Transcription",
  "editor.selectSpeaker": "Select Speaker",
  "editor.selectNoiseTag": "Select Noise Tag",
  "editor.autosave": "Auto-save enabled for this scenario.",
  "editor.regions": "Regions",
  "editor.labels": "Labels",
  "editor.relations": "Relations",
  "editor.noRegionSelected": "No Region selected",
  "editor.deleteSubtitle": "Delete Subtitle",
  "editor.add": "Add",
  "editor.update": "Update",
  "editor.accept": "Accept",
  "editor.revise": "Revise",
  "editor.glossary": "Glossary",

  // --- датасеты ---
  "ds.createNewInstance": "Create New Dataset Instance",
  "ds.instanceName": "Instance_Name",
  "ds.instanceDescription": "Instance_Description",
  "ds.datasetType": "Dataset_Type",
  "ds.confirm": "Confirm",
  "ds.selectFile": "Select File",
  "ds.selectFileFormat": "Select File Format",
  "ds.upload": "Upload",

  // --- создание проекта ---
  "create.title": "Create a Project",
  "create.titleField": "Title:",
  "create.descriptionField": "Description:",
  "create.selectCategory": "Select a Category to Work in:",
  "create.finalize": "Finalize Project",
  "create.createProject": "Create Project",
  "my.summary.title": "My output",
  "my.summary.period.today": "Today",
  "my.summary.period.week": "Last 7 days",
  "my.summary.stage.annotation": "Annotation",
  "my.summary.stage.review": "Review",
  "my.summary.stage.supercheck": "Super check",
  "my.summary.tasks": "tasks submitted",
  "my.summary.duration": "audio duration",
  "my.summary.segments": "segments",
  "my.summary.returned": "sent for revision",  "audio.upload.button": "Upload audio",
  "audio.upload.title": "Upload audio files",
  "audio.upload.choose": "Choose files",
  "audio.upload.limits": "WAV, mp3, m4a. Up to 50 files at a time, 100 MB each.",
  "audio.upload.selected": "Selected",
  "audio.upload.domain": "Domain",
  "audio.upload.runLlm": "Run through LLM",
  "audio.upload.runLlmHint": "The file becomes available to annotators only after pre-annotation.",
  "audio.upload.sending": "Uploading file",
  "audio.upload.start": "Upload",
  "audio.upload.done": "Uploaded",
  "audio.upload.failed": "failed",
  "audio.upload.markup": "Markup file (CSV)",
  "audio.upload.markupHint": "Optional. A table with audio and text columns: the audio file name and a draft text. The draft lands in the annotator's task right away — to correct, not retype. It also applies to previously uploaded files with the same names, so audio can be uploaded in batches and the markup as a single file.",
  "audio.upload.markupRows": "rows",
  "audio.upload.markupEmpty": "empty texts",
  "audio.upload.markupCovered": "Selected audio covered by the markup",
  "audio.upload.markupExisting": "Matches among already uploaded files",
  "audio.upload.markupNoLlm": "ASR pre-annotation is skipped for files covered by the markup — the draft comes from the file.",
  "audio.upload.markupL2": "Copy the draft into the normalised layer (L2) as well",
  "audio.upload.markupRemove": "Remove",
  "audio.upload.markupApplied": "Markup applied",
  "audio.upload.markupNotFound": "rows with no matching file in the dataset",
  "audio.upload.markupInWork": "already being annotated — left as is",
  "audio.upload.markupAmbiguous": "name repeats in the dataset — left as is",
  "audio.upload.markupBusy": "ASR pre-annotation in progress — left as is",
  "audio.preannotation.title": "Pre-annotation",
  "audio.preannotation.done": "done",
  "audio.preannotation.inQueue": "in queue",
  "audio.preannotation.failed": "failed",
  "audio.preannotation.retry": "Retry",
  "log.hint": "Background operations on this dataset: data upload and project export. Pre-annotation progress is shown on the Datasets tab.",
  "log.task.upload": "Upload data into dataset",
  "log.task.exportNew": "Export project (as a new record)",
  "log.task.exportInPlace": "Export project (update records)",
  "log.pre.title": "Pre-annotation log",
  "log.pre.hint": "Every processing attempt on its own row, including retries after failures.",
  "log.pre.file": "File",
  "log.pre.attempt": "Attempt",
  "log.pre.segments": "Segments",
  "log.pre.spent": "Processing",
  "log.pre.started": "Started",
  "log.pre.sec": "s",
  "log.pre.status.done": "Done",
  "log.pre.status.failed": "Failed",
  "log.pre.status.running": "Running",
  "col.audioUrl": "Audio URL",
  "col.speakerCount": "Speakers count",
  "col.speakersJson": "Speakers",
  "col.metadataJson": "Metadata",
  "col.draftDataJson": "Pre-annotation draft",
  "col.transcribedJson": "Transcription",
  "col.machineTranscribedJson": "Machine transcription",
  "col.finalTranscribedJson": "Final transcription",
  "col.predictionJson": "Model prediction",
  "col.preannotationStatus": "Pre-annotation status",
  "col.preannotationError": "Pre-annotation error",
  "col.preannotationFinishedAt": "Pre-annotation finished",
  "col.originalFilename": "Original filename",
  "col.instanceId": "Dataset",
  "col.parentData": "Source record",
  "col.preannotation.none": "Not required",
  "log.pre.status.pending": "In queue",
  "table.showFull": "Open in full",
  "stage.annotationOnly": "Annotation only",
  "stage.reviewEnabled": "Annotation and review",
  "stage.supercheckEnabled": "Annotation, review, super check",
  "proj.pullNewData": "Pull new data",
  "Failed to pull new data items": "Failed to pull new data items",
  "create.missing": "To create the project, fill in",
  "autoAnn.label": "Accept pre-annotation as finished work:",
  "autoAnn.none": "No — people annotate",
  "autoAnn.annotation": "Close the annotation stage",
  "autoAnn.review": "Close annotation and review",
  "autoAnn.supercheck": "Close all stages",
  "acoustic.label": "Normalized text available from stage:",
  "acoustic.fromAnnotation": "From annotation",
  "acoustic.fromReview": "From review",
  "acoustic.fromSupercheck": "From super check",
  "project.notPublished": "The project is not published — tasks exist but are not handed out.",
  "project.publish": "Publish",
  "project.publishFailed": "Failed to publish the project",
  "unassigned.tab": "Unassigned tasks",
  "unassigned.hint": "Tasks nobody has taken yet. You can hand one to a specific person.",
  "unassigned.free": "Free",
  "unassigned.choosePerson": "Choose a person",
  "unassigned.assign": "Assign",
  "unassigned.assignFailed": "Failed to assign tasks",
  "unassigned.stage.annotation": "For annotation",
  "unassigned.stage.review": "For review",
  "unassigned.stage.supercheck": "For super check",
  "Version": "Version",
  "Frontend": "Frontend",
  "Backend": "Backend",
};

export default en;
